// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"BrandedModalHeader_closeButton__1LGqH","header":"BrandedModalHeader_header__2lcMx","logo":"BrandedModalHeader_logo__2TN9k"};